import { hashHistory } from 'react-router';

import { toast } from '@finn-no/common-browserbundle';
import { trackEventObject } from '../../../services/trackingService';

import {
    ACCEPT_AGREEMENT_START,
    ACCEPT_AGREEMENT_SUCCESS,
    ACCEPT_AGREEMENT_ERROR,
    REJECT_AGREEMENT_START,
    REJECT_AGREEMENT_SUCCESS,
    REJECT_AGREEMENT_ERROR,
    NEW_AGREEMENT_DATA_RECEIVED,
} from './agreementActionTypes';
import { UPDATED_SAFE_TRADE_STATUS } from '../safeTradeActionTypes.js';
import mapResponse from '../../responseMapper.js';
import viewActions from '../../viewActions.js';
import { put } from '../../../services/jsonfetchservice';

function updateStatus({
    actionType,
    body = {},
    dispatch,
    errorType,
    itemType,
    itemId,
    partnerId,
    redirectOnError,
    startType,
    successType,
    toastMessage,
}) {
    dispatch({
        type: startType,
    });

    const payload = Object.assign(
        {},
        {
            actionType,
        },
        body
    );

    return put(`/safe-trade/${itemType}/${itemId}/${partnerId}.json`, payload)
        .then(response => response.json())
        .then(data => mapResponse(data, partnerId, itemType, itemId))
        .then(mappedResponse => {
            dispatch({
                type: NEW_AGREEMENT_DATA_RECEIVED,
                payload: mappedResponse.agreement,
            });

            dispatch({
                type: UPDATED_SAFE_TRADE_STATUS,
                payload: mappedResponse.safeTrade.viewStatus,
            });

            dispatch({
                type: successType,
            });
            hashHistory.replace('/samtale');

            if (toastMessage) {
                toast({ message: toastMessage });
            }
        })
        .catch(() => {
            dispatch({
                type: errorType,
            });
            hashHistory.replace(redirectOnError);
        });
}

export function acceptAgreement({ itemType, itemId, partnerId }) {
    trackEventObject({
        analyticsName: 'trade.make-agreement.seller-approves-agreement',
        eventFlags: 'success',
        context: {
            finnkode: itemId,
        },
    });

    return dispatch =>
        updateStatus({
            dispatch,
            itemType,
            itemId,
            partnerId,
            actionType: viewActions.ACCEPT_AGREEMENT,
            startType: ACCEPT_AGREEMENT_START,
            successType: ACCEPT_AGREEMENT_SUCCESS,
            errorType: ACCEPT_AGREEMENT_ERROR,
            redirectOnError: '/godkjenn-avtale-feilet',
            toastMessage: 'Avtalen er akseptert',
        });
}

export function rejectAgreement({ itemType, itemId, partnerId }) {
    trackEventObject({
        analyticsName: 'trade.make-agreement.seller-rejects-agreement',
        context: {
            finnkode: itemId,
        },
    });

    return dispatch =>
        updateStatus({
            dispatch,
            itemType,
            itemId,
            partnerId,
            actionType: viewActions.REJECT_AGREEMENT,
            startType: REJECT_AGREEMENT_START,
            successType: REJECT_AGREEMENT_SUCCESS,
            errorType: REJECT_AGREEMENT_ERROR,
            redirectOnError: '/avsla-avtale-feilet',
        });
}



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/agreementActions.js